import { Component } from '@angular/core';
import * as Rx from 'rxjs';
import { AppService, AppSettingService } from "../app.service";
import { NotificationService } from './notification.service';
import { NotificationAPIService, INotification } from './notification-api.service';
import { UserInfoService } from '../user/user-info.service';
import { CommentAPIService } from '../comment/comment.service';
import { JobPostService } from "../job/job-post.service";

@Component({
	selector: 'app-notification',
	templateUrl: './notification.component.html',
	standalone: false
})
export class NotificationComponent {
	private notificationWatcher: Rx.Subscription = null;
	private isAnonymous: boolean = true;
	notificationReady: boolean = false;

	public get notifications(): INotification[] {
		return this.notificationSrv.notifications;
	}

	private downloadNotifications(): void {
		if (!this.isAnonymous) {
			this.notificationReady = false;
			this.notificationSrv.downloadNotifications().subscribe({
				next: (response) => {
					this.notificationReady = response;
				},
				error: (err) => {
					console.log(err);
				}
			});
		}
	}

	dismissNotification(note: INotification): void {
		this.notificationtAPI.deleteNotification(note.NotificationPersonId).subscribe({
			next: () => {
				this.downloadNotifications();
			},
			error: (err) => {
				console.log(err);
			}
		});
	}

	viewNotification(note: INotification): void {
		// 6: comment
		if (note.NotificationId === '6') {
			//handle sending user to comment URLs for notification they clicked on
			if (note.ActionUrl.split('?').length > 1) {
				let urlRoute = note.ActionUrl.split('?')[0];
				this.appSrv.redirectReload(urlRoute, { queryParams: { "commentPostId": note.CommentPostId } });
			}
			else {
				this.appSrv.goTo(note.ActionUrl);
			}
		}
		// 9: job offer
		else if (note.NotificationId == "9") {
			this.jobSrv.viewOffer(note.JobPostId).subscribe();
		}
		else {
			//handle sending user to all other URLs for notification they clicked on
			if (note.ActionUrl !== "") {
				this.appSrv.goTo(note.ActionUrl);
			}
		}
	}

	private handleAfterNotificationDelete(note: INotification): void {
		this.downloadNotifications();
		this.viewNotification(note);
	}

	// handle all none-view notifications
	handleNotification(note: INotification): void {
		// 6: comment
		if (note.NotificationId === "6") {
			let notificationPersonIDs = []; //used to delete notifications
			let commentPostIDsToHighlight = []; //used for comment highlighting on comments page

			//delete all comment type notifications for current comment career map object:
			//to do this, build a comma delimited string of all 'NotificationPersonId's to delete...		
			//for comment handling, this url should be filled in with a career map object id path param
			//url must follow format: "/Comment/{object id}?..."
			let currentUrlPathParamCareerId = note.ActionUrl.split('/')[2].split('?')[0]; //object id path param
			for (var i = 0; i < this.notifications.length; i++) {
				if (this.notifications[i].NotificationId === '6' && this.notifications[i].CareerId === currentUrlPathParamCareerId) {
					console.log(this.notifications[i].NotificationPersonId);
					notificationPersonIDs.push(this.notifications[i].NotificationPersonId);
					commentPostIDsToHighlight.push(this.notifications[i].CommentPostId);
				}
			}
			if (notificationPersonIDs.length > 0) {
				//this only happens for type-6 (comment notifications)
				this.commentAPI.commentPostIDsToHighlight = commentPostIDsToHighlight; //needed by comments page for highlighting unread comments: this is populated same place notificationPersonIDs so will have items here.
				this.notificationtAPI.deleteMultipleNotifications(notificationPersonIDs).subscribe({
					next: () => {
						this.handleAfterNotificationDelete(note);
					},
					error: (err) => {
						console.log(err);
					}
				});
			}
		}
		else {
			this.notificationtAPI.deleteNotification(note.NotificationPersonId).subscribe({
				next: () => {
					this.handleAfterNotificationDelete(note);
				},
				error: (err) => {
					console.log(err);
				}
			});
		}
	}

	private watchNotification(): void {
		this.notificationWatcher = this.notificationSrv.notificationChanged.subscribe({
			next: (value: any) => {
				if (value != null) {
					this.downloadNotifications();
				}
			},
			error: (err: any) => {
				console.log(err);
			}
		});
	}

	ngOnDestroy(): void {
		if (this.notificationWatcher) {
			this.notificationWatcher.unsubscribe()
		}
	}

	constructor(
		public appSetting: AppSettingService,
		private appSrv: AppService,
		private commentAPI: CommentAPIService,
		private jobSrv: JobPostService,
		private notificationSrv: NotificationService,
		private notificationtAPI: NotificationAPIService,
		public userInfo: UserInfoService
	) {
		this.isAnonymous = this.userInfo.isAnonymous();
		this.watchNotification();
	}
}


